import { autoserialize, autoserializeAs } from 'cerialize';
import { DriverFareCalculation } from './driver-fare-calculation';
import { TollReimbursement } from './toll-reimbursement';

export class FareReviewDetail {
  @autoserialize
  reservationId: number;

  @autoserialize
  fareCalculationId: number;

  @autoserialize
  period2Polyline: string;

  @autoserialize
  period3EstimatedPolyline: string;

  @autoserialize
  period3ActualPolyline: string;

  @autoserialize
  fareReviewTriggerResultName: Array<string>;

  @autoserializeAs(DriverFareCalculation)
  driverFareCalculations: Array<DriverFareCalculation>;

  @autoserializeAs(TollReimbursement)
  tollReimbursement: TollReimbursement;
}
